"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: miimosa/common/v1/commitment.proto
Object.defineProperty(exports, "__esModule", { value: true });
exports.commitmentTriggerEventToJSON = exports.commitmentTriggerEventFromJSON = exports.CommitmentTriggerEvent = exports.commitmentAmountTypeToJSON = exports.commitmentAmountTypeFromJSON = exports.CommitmentAmountType = void 0;
/* eslint-disable */
exports.CommitmentAmountType = {
    COMMITMENT_AMOUNT_TYPE_UNSPECIFIED: "COMMITMENT_AMOUNT_TYPE_UNSPECIFIED",
    COMMITMENT_AMOUNT_TYPE_FIXED: "COMMITMENT_AMOUNT_TYPE_FIXED",
    COMMITMENT_AMOUNT_TYPE_PER_COLLECT: "COMMITMENT_AMOUNT_TYPE_PER_COLLECT",
    COMMITMENT_AMOUNT_TYPE_PLEDGE: "COMMITMENT_AMOUNT_TYPE_PLEDGE",
    COMMITMENT_AMOUNT_TYPE_TO_SUCCEED: "COMMITMENT_AMOUNT_TYPE_TO_SUCCEED",
    COMMITMENT_AMOUNT_TYPE_TO_FULL: "COMMITMENT_AMOUNT_TYPE_TO_FULL",
    UNRECOGNIZED: "UNRECOGNIZED",
};
function commitmentAmountTypeFromJSON(object) {
    switch (object) {
        case 0:
        case "COMMITMENT_AMOUNT_TYPE_UNSPECIFIED":
            return exports.CommitmentAmountType.COMMITMENT_AMOUNT_TYPE_UNSPECIFIED;
        case 1:
        case "COMMITMENT_AMOUNT_TYPE_FIXED":
            return exports.CommitmentAmountType.COMMITMENT_AMOUNT_TYPE_FIXED;
        case 2:
        case "COMMITMENT_AMOUNT_TYPE_PER_COLLECT":
            return exports.CommitmentAmountType.COMMITMENT_AMOUNT_TYPE_PER_COLLECT;
        case 3:
        case "COMMITMENT_AMOUNT_TYPE_PLEDGE":
            return exports.CommitmentAmountType.COMMITMENT_AMOUNT_TYPE_PLEDGE;
        case 4:
        case "COMMITMENT_AMOUNT_TYPE_TO_SUCCEED":
            return exports.CommitmentAmountType.COMMITMENT_AMOUNT_TYPE_TO_SUCCEED;
        case 5:
        case "COMMITMENT_AMOUNT_TYPE_TO_FULL":
            return exports.CommitmentAmountType.COMMITMENT_AMOUNT_TYPE_TO_FULL;
        case -1:
        case "UNRECOGNIZED":
        default:
            return exports.CommitmentAmountType.UNRECOGNIZED;
    }
}
exports.commitmentAmountTypeFromJSON = commitmentAmountTypeFromJSON;
function commitmentAmountTypeToJSON(object) {
    switch (object) {
        case exports.CommitmentAmountType.COMMITMENT_AMOUNT_TYPE_UNSPECIFIED:
            return "COMMITMENT_AMOUNT_TYPE_UNSPECIFIED";
        case exports.CommitmentAmountType.COMMITMENT_AMOUNT_TYPE_FIXED:
            return "COMMITMENT_AMOUNT_TYPE_FIXED";
        case exports.CommitmentAmountType.COMMITMENT_AMOUNT_TYPE_PER_COLLECT:
            return "COMMITMENT_AMOUNT_TYPE_PER_COLLECT";
        case exports.CommitmentAmountType.COMMITMENT_AMOUNT_TYPE_PLEDGE:
            return "COMMITMENT_AMOUNT_TYPE_PLEDGE";
        case exports.CommitmentAmountType.COMMITMENT_AMOUNT_TYPE_TO_SUCCEED:
            return "COMMITMENT_AMOUNT_TYPE_TO_SUCCEED";
        case exports.CommitmentAmountType.COMMITMENT_AMOUNT_TYPE_TO_FULL:
            return "COMMITMENT_AMOUNT_TYPE_TO_FULL";
        case exports.CommitmentAmountType.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
exports.commitmentAmountTypeToJSON = commitmentAmountTypeToJSON;
exports.CommitmentTriggerEvent = {
    COMMITMENT_TRIGGER_EVENT_UNSPECIFIED: "COMMITMENT_TRIGGER_EVENT_UNSPECIFIED",
    COMMITMENT_TRIGGER_EVENT_COLLECT_PROGRESS: "COMMITMENT_TRIGGER_EVENT_COLLECT_PROGRESS",
    COMMITMENT_TRIGGER_EVENT_COLLECTED_AMOUNT: "COMMITMENT_TRIGGER_EVENT_COLLECTED_AMOUNT",
    COMMITMENT_TRIGGER_EVENT_PLEDGE: "COMMITMENT_TRIGGER_EVENT_PLEDGE",
    UNRECOGNIZED: "UNRECOGNIZED",
};
function commitmentTriggerEventFromJSON(object) {
    switch (object) {
        case 0:
        case "COMMITMENT_TRIGGER_EVENT_UNSPECIFIED":
            return exports.CommitmentTriggerEvent.COMMITMENT_TRIGGER_EVENT_UNSPECIFIED;
        case 1:
        case "COMMITMENT_TRIGGER_EVENT_COLLECT_PROGRESS":
            return exports.CommitmentTriggerEvent.COMMITMENT_TRIGGER_EVENT_COLLECT_PROGRESS;
        case 2:
        case "COMMITMENT_TRIGGER_EVENT_COLLECTED_AMOUNT":
            return exports.CommitmentTriggerEvent.COMMITMENT_TRIGGER_EVENT_COLLECTED_AMOUNT;
        case 3:
        case "COMMITMENT_TRIGGER_EVENT_PLEDGE":
            return exports.CommitmentTriggerEvent.COMMITMENT_TRIGGER_EVENT_PLEDGE;
        case -1:
        case "UNRECOGNIZED":
        default:
            return exports.CommitmentTriggerEvent.UNRECOGNIZED;
    }
}
exports.commitmentTriggerEventFromJSON = commitmentTriggerEventFromJSON;
function commitmentTriggerEventToJSON(object) {
    switch (object) {
        case exports.CommitmentTriggerEvent.COMMITMENT_TRIGGER_EVENT_UNSPECIFIED:
            return "COMMITMENT_TRIGGER_EVENT_UNSPECIFIED";
        case exports.CommitmentTriggerEvent.COMMITMENT_TRIGGER_EVENT_COLLECT_PROGRESS:
            return "COMMITMENT_TRIGGER_EVENT_COLLECT_PROGRESS";
        case exports.CommitmentTriggerEvent.COMMITMENT_TRIGGER_EVENT_COLLECTED_AMOUNT:
            return "COMMITMENT_TRIGGER_EVENT_COLLECTED_AMOUNT";
        case exports.CommitmentTriggerEvent.COMMITMENT_TRIGGER_EVENT_PLEDGE:
            return "COMMITMENT_TRIGGER_EVENT_PLEDGE";
        case exports.CommitmentTriggerEvent.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
exports.commitmentTriggerEventToJSON = commitmentTriggerEventToJSON;
//# sourceMappingURL=commitment.js.map